import { useCallback, useEffect, useState } from 'react';
import api from '../config/configApi';
import NOVIDADES from '../Data/novidades';
import { hasPermissao } from '../utils/acl/permissoes';

// Quais novidades a pessoa já leu, uma a uma. O servidor guarda a lista de ids lidos
// (user.novidadesLidas, JSON); a resposta fica em sessionStorage para não buscar a cada
// página. Navbar (selo + popup) e a página /novidades ficam sincronizados por um evento.
const CHAVE_SESSAO = 'novidadesLidas';
const EVENTO = 'novidades-lidas';

const lerSessao = () => {
  const texto = sessionStorage.getItem(CHAVE_SESSAO);
  if (texto === null) return null;
  try {
    return JSON.parse(texto);
  } catch {
    return [];
  }
};

const gravarSessao = (lidas) => {
  sessionStorage.setItem(CHAVE_SESSAO, JSON.stringify(lidas));
  window.dispatchEvent(new Event(EVENTO));
};

const visiveis = () => NOVIDADES
  .filter((n) => !n.permissoes || hasPermissao(n.permissoes))
  .sort((a, b) => b.id.localeCompare(a.id));

export default function useNovidades() {
  const [lidas, setLidas] = useState(lerSessao);

  useEffect(() => {
    const aoMudar = () => setLidas(lerSessao());
    window.addEventListener(EVENTO, aoMudar);
    if (lerSessao() === null) {
      api.get('/profile/view-profile')
        .then(({ data }) => {
          let doServidor = [];
          try {
            doServidor = JSON.parse(data?.user?.novidadesLidas || '[]');
          } catch {
            doServidor = [];
          }
          gravarSessao(Array.isArray(doServidor) ? doServidor : []);
        })
        .catch(() => {});
    }
    return () => window.removeEventListener(EVENTO, aoMudar);
  }, []);

  const lista = visiveis();
  const carregado = lidas !== null;
  const foiLida = (id) => carregado && lidas.includes(id);
  const naoLidas = carregado ? lista.filter((n) => !lidas.includes(n.id)) : [];

  // Marca (lida = true) ou desmarca (lida = false). Atualiza a tela na hora e depois o
  // servidor; se o servidor falhar, a tela volta ao que o servidor tinha no próximo acesso.
  const marcar = useCallback(async (ids, lida = true) => {
    const atuais = new Set(lerSessao() || []);
    ids.forEach((id) => (lida ? atuais.add(id) : atuais.delete(id)));
    gravarSessao([...atuais]);
    try {
      const { data } = await api.put('/profile/novidades-lidas', { ids, lida }, { suppressErrorModal: true });
      if (Array.isArray(data?.novidadesLidas)) gravarSessao(data.novidadesLidas);
    } catch {
      // Não atrapalha o uso agora.
    }
  }, []);

  const marcarTodasLidas = () => marcar(lista.map((n) => n.id), true);

  return {
    lista, naoLidas, carregado, foiLida, marcar, marcarTodasLidas,
  };
}
